import * as React from 'react'

/**
 * @description RubleExchange icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RubleExchange } from '@sravni/design-system-icons'
 *
 * <RubleExchange />
 * ```
 */
export const RubleExchange = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="RubleExchange" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.747 4.82a7.461 7.461 0 0 1 5.168-2.042c4.035 0 7.307 3.122 7.307 6.974 0 .537-.07 1.058-.19 1.561M15.252 15.18a7.462 7.462 0 0 1-5.167 2.042c-4.035 0-7.307-3.122-7.307-6.974 0-.537.07-1.058.19-1.561"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.444 9.444 2.778 7.778 1.11 9.444M15.556 10.444l1.666 1.667 1.667-1.667"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.651 14.667a.563.563 0 0 1-.563-.563V7a1 1 0 0 1 1-1h.685c1.092 0 1.901.214 2.427.643.533.43.8 1.052.8 1.87 0 .55-.13 1.023-.388 1.42-.258.388-.642.688-1.15.898-.5.21-1.122.316-1.864.316h-.384v2.957c0 .31-.252.563-.563.563Zm-1.257-1.651a.394.394 0 1 1 0-.79h3.49a.394.394 0 1 1 0 .79h-3.49Zm.067-1.87a.461.461 0 0 1 0-.922h1.737v.923H7.46Zm1.974-.922c.324 0 .938-.053 1.289-.158.358-.105.633-.279.825-.522.192-.242.288-.574.288-.995 0-.55-.175-.959-.526-1.226-.35-.267-.896-.4-1.638-.4h-.26a.2.2 0 0 0-.2.2v2.901c0 .11.06.2.17.2h.052Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth=".3"
      strokeLinejoin="round"
    />
  </svg>
))
